<aside
    class="sidebar"
    [class.sidebar-mobile]="sidebarService.isBelowTabletWidth()"
    [class.sidebar-wider]="sidebarService.isBelowTabletWidth()"
    [class.sidebar-hidden]="sidebarService.isBelowTabletWidth() && !sidebarService.isNavSidebarEnabled()"
    [class.sidebar-fullscreen]="sidebarService.isBelowMobileWidth() && sidebarService.isNavSidebarEnabled()"
    data-testid="nav-sidebar"
>
    <section>
        <div class="sidebar-header">
            <div class="sidebar-header-logo">
                @if (!sidebarService.isBelowMobileWidth() && sidebarService.isBelowTabletWidth()) {
                    <img src="assets/icons/close-nav-cross.svg" alt="Burger Icon" class="sidebar-header-close sidebar-header-logo-close" (click)="sidebarService.disableSidebar()" data-testid="nav-sidebar-close-button" />
                }
                <div class="sidebar-header-logo-img" (click)="sidebarService.disableSidebar()" [routerLink]="['/home']" data-testid="nav-sidebar-logo-link">
                    <img src="assets/icons/dashboard-logo.svg" alt="Airwallet Logo" />
                    @if (dashboardOwnerUser.operatorName) {
                        <div class="sidebar-header-logo-img-operator">
                            <app-aw-tooltip [tooltipTitle]="'navbar.main_operator' | translate">
                                <ng-container tooltip_element_ref>
                                    <img width=".875rem" height="auto" src="assets/icons/operator-notify-icon.svg" alt="Info" />
                                </ng-container>

                                <ng-container description>
                                    <div>
                                        <span style="font-weight: 600"> {{ dashboardOwnerUser.operatorName }} </span>{{ "navbar.main_operator_description_long_pt1" | translate }}
                                    </div>
                                    <div class="mt-2">
                                        {{ "navbar.main_operator_description_long_pt2" | translate }}
                                    </div>
                                    <div class="mt-2">
                                        {{ "navbar.main_operator_description_long_pt3" | translate }}
                                        {{ dashboardOwnerUser.operatorName }}
                                        {{ "navbar.main_operator_description_long_pt4" | translate }}
                                    </div>
                                </ng-container>
                            </app-aw-tooltip>
                        </div>
                    }
                </div>
                <div class="sidebar-header-logo-titles">
                    @if (samlService.samlMembershipOwners()) {
                        <app-owner-selector />
                    } @else {
                        <div class="ellipsis">
                            <span>
                                @if (isDemo) {
                                    <strong [title]="'navbar.demo_acc' | translate">{{ "navbar.demo_acc" | translate }}</strong>
                                } @else {
                                    <strong [title]="dashboardOwnerUser.company_name">{{ dashboardOwnerUser.company_name }}</strong>
                                }
                            </span>
                        </div>
                    }
                    <div class="ellipsis" [title]="authenticatedUser.name">
                        <span style="font-size: 12px">{{ authenticatedUser.name }}</span>
                    </div>
                </div>
            </div>
            @if (sidebarService.isBelowMobileWidth()) {
                <img src="assets/icons/close-nav-cross.svg" alt="Burger Icon" class="sidebar-header-close" (click)="sidebarService.disableSidebar()" data-testid="nav-sidebar-close-button" />
            }
        </div>
    </section>
    <section class="sidebar-section">
        <div>
            <nav class="nav">
                @if (authService.allowAccess("home", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-home" (click)="sidebarService.disableSidebar()" [routerLink]="['/home']" data-testid="nav-sidebar-home-link">
                        <img src="assets/icons/nav-icons-black/home.svg" alt="overview icon" />
                        <span>{{ "navbar.home" | translate }}</span>
                    </a>
                }
                @if (authService.allowAccess("transactions", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-transactions" (click)="sidebarService.disableSidebar()" [routerLink]="['/transactions']" data-testid="nav-sidebar-transactions-link">
                        <img src="assets/icons/nav-icons-black/transactions.svg" alt="transactions icon" />
                        <span>{{ "navbar.transactions" | translate }}</span>
                    </a>
                }
                @if (authService.customerFirestore()?.wallet_float_owner) {
                    <a role="button" class="nav-link" id="nav-topups" (click)="sidebarService.disableSidebar()" [routerLink]="['/topups']" data-testid="nav-sidebar-topups-link">
                        <img src="assets/icons/nav-icons-black/topups.svg" alt="topups icon" />
                        <span>{{ "navbar.topups" | translate }}</span>
                    </a>
                }
                @if (authService.allowAccess("locations", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-locations" (click)="sidebarService.disableSidebar()" [routerLink]="['/locations']" data-testid="nav-sidebar-locations-link">
                        <img src="assets/icons/nav-icons-black/locations.svg" alt="locations icon" />
                        <span>{{ "misc.locations" | translate }}</span>
                    </a>
                }
                @if (authService.allowAccess("bookings", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-bookings" (click)="sidebarService.disableSidebar()" [routerLink]="['/bookings']" data-testid="nav-sidebar-bookings-link">
                        <img src="assets/icons/nav-icons-black/bookings.svg" alt="bookings icon" />
                        <span>{{ "navbar.bookings" | translate }}</span>
                        @if (isTrialGranted("bookings")()) {
                            <img class="nav-link-tail" src="assets/icons/upgrade-star-green.svg" alt="trial-star" />
                        }
                    </a>
                }
                @if (authService.allowAccess("actions", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-actions" (click)="sidebarService.disableSidebar()" [routerLink]="['/actions']" data-testid="nav-sidebar-actions-link">
                        <img src="assets/icons/nav-icons-black/actions.svg" alt="actions icon" />
                        <span>{{ "operator.filter_bar.actions" | translate }}</span>
                        @if (!isActionsEnabled()) {
                            <img class="nav-link-tail" src="assets/icons/upgrade-star-blue.svg" alt="upgrade-star" />
                        } @else if (isTrialGranted("actions")()) {
                            <img class="nav-link-tail" src="assets/icons/upgrade-star-green.svg" alt="trial-star" />
                        }
                    </a>
                }
                <!-- TODO: HARDCODED UID to prevent a customer from accessing, needs to be fixed in future with refactor of devices page -->
                @if (authService.allowAccess("devices", authService.getRole()) && dashboardOwnerUser.uid !== "cGk0rhj698bvWMyKXK2Fr2DCywh1") {
                    <a role="button" class="nav-link" id="nav-devices" (click)="sidebarService.disableSidebar()" [routerLink]="['/devices']" data-testid="nav-sidebar-devices-link">
                        <img src="assets/icons/nav-icons-black/device.svg" alt="device icon" />
                        <span>{{ "navbar.devices" | translate }}</span>
                        @if (!isOperatorDevicesEnabled()) {
                            <img class="nav-link-tail" src="assets/icons/upgrade-star-blue.svg" alt="upgrade-star" />
                        } @else if (isTrialGranted("operator_devices")()) {
                            <img class="nav-link-tail" src="assets/icons/upgrade-star-green.svg" alt="trial-star" />
                        }
                    </a>
                }
                @if (authService.allowAccess("health-monitor", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-health-monitor" (click)="sidebarService.disableSidebar()" [routerLink]="['/health-monitor']" data-testid="nav-sidebar-health-monitor-link">
                        <img src="assets/icons/nav-icons-black/health-monitor.svg" alt="health-monitor icon" />
                        <span>{{ "navbar.health-monitor" | translate }}</span>
                        @if (!isOperatorHealthMonitorEnabled()) {
                            <img class="nav-link-tail" src="assets/icons/upgrade-star-blue.svg" alt="upgrade-star" />
                        } @else if (isTrialGranted("operator_health_monitor")()) {
                            <img class="nav-link-tail" src="assets/icons/upgrade-star-green.svg" alt="trial-star" />
                        }
                    </a>
                }
            </nav>
            @if (authService.isOperator()) {
                <nav class="nav">
                    <div class="nav-title">
                        <strong>{{ "navbar.operator" | translate }}</strong>
                    </div>
                    @if (authService.allowAccess("customers", authService.getRole())) {
                        <a role="button" class="nav-link" id="nav-customers" (click)="sidebarService.disableSidebar()" [routerLink]="['/customers']" data-testid="nav-sidebar-customers-link">
                            <img src="assets/icons/nav-icons-black/customers.svg" alt="customers icon" />
                            <span>{{ "customers.customers" | translate }}</span>
                        </a>
                    }
                    @if (authService.allowAccess("contracts", authService.getRole())) {
                        <a role="button" class="nav-link" id="nav-contracts" (click)="sidebarService.disableSidebar()" [routerLink]="['/contracts']" data-testid="nav-sidebar-contracts-link">
                            <img src="../../../assets/icons/nav-icons-black/contracts.svg" alt="contract icon" />
                            <span>{{ "navbar.contracts" | translate }}</span>
                        </a>
                    }
                </nav>
            }

            <nav class="nav">
                @if (authService.allowAccessToAny(["users", "coupons", "push-notifications", "notice-boards"], authService.getRole())) {
                    <div class="nav-title">
                        <strong>{{ "navbar.engagement" | translate }}</strong>
                    </div>
                }

                @if (authService.allowAccess("users", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-users" (click)="sidebarService.disableSidebar()" [routerLink]="['/users']" data-testid="nav-sidebar-users-link">
                        <img src="assets/icons/nav-icons-black/users.svg" alt="users icon" />
                        <span>{{ "navbar.users" | translate }}</span>
                        @if (isTrialGranted("user")()) {
                            <img class="nav-link-tail" src="assets/icons/upgrade-star-green.svg" alt="trial-star" />
                        }
                    </a>
                }

                @if (authService.allowAccess("notice-boards", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-notice-boards" (click)="sidebarService.disableSidebar()" [routerLink]="['/notice-boards']" data-testid="nav-sidebar-notice-boards-link">
                        <img src="assets/icons/nav-icons-black/notice-boards.svg" alt="notice-boards icon" />
                        <span>{{ "navbar.notice-boards" | translate }}</span>
                        @if (!isNoticeBoardsEnabled()) {
                            <img class="nav-link-tail" src="assets/icons/upgrade-star-blue.svg" alt="upgrade-star" />
                        } @else if (isTrialGranted("notice_boards")()) {
                            <img class="nav-link-tail" src="assets/icons/upgrade-star-green.svg" alt="trial-star" />
                        } @else {
                            <div class="nav-link-tail beta">BETA</div>
                        }
                    </a>
                }

                @if (this.authService.isCouponAllowed() && authService.allowAccess("coupons", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-coupons" (click)="sidebarService.disableSidebar()" [routerLink]="['/coupons']" data-testid="nav-sidebar-coupons-link">
                        <img src="assets/icons/nav-icons-black/coupons.svg" alt="coupon icon" />
                        <span>{{ "navbar.coupons" | translate }}</span>
                    </a>
                }

                @if (authService.allowAccess("push-notifications", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-push-notifications" (click)="sidebarService.disableSidebar()" [routerLink]="['/push-notifications']" data-testid="nav-sidebar-push-notifications-link">
                        <img src="assets/icons/nav-icons-black/push-notifications.svg" alt="push-notifications icon" />
                        <span>{{ "navbar.push-notifications" | translate }}</span>
                    </a>
                }
            </nav>
        </div>

        <div class="end">
            <a role="button" class="end-feedback" id="feedback" href="https://product-hub.tools.airwallet.net/f/dashboard-form" target="_blank" data-testid="nav-sidebar-feedback-link">
                <span>{{ "navbar.share_feedback" | translate }}</span>
                <img src="assets/icons/arrow-right-black.svg" alt="arrow right" />
            </a>
            <nav class="nav">
                <div class="nav-title">
                    <strong>{{ "navbar.settings" | translate }}</strong>
                </div>

                @if (authService.allowAccess("account", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-account" (click)="sidebarService.disableSidebar()" [routerLink]="['/account']" data-testid="nav-sidebar-account-link">
                        <img src="assets/icons/nav-icons-black/account.svg" alt="account icon" />
                        <span>{{ "navbar.settings_account" | translate }}</span>
                    </a>
                }
                @if (authService.isBillingAllowed() && authService.allowAccess("billing", authService.getRole()) && !dashboardOwnerUser.settings.is_regular) {
                    <a role="button" class="nav-link" id="nav-billing" (click)="sidebarService.disableSidebar()" [routerLink]="['/billing']" data-testid="nav-sidebar-billing-link">
                        <img src="assets/icons/nav-icons-black/billing.svg" alt="billing icon" />
                        <span>{{ "misc.billing" | translate }}</span>
                    </a>
                }
                @if (authService.allowAccess("settlements", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-settlements" (click)="sidebarService.disableSidebar()" [routerLink]="['/settlements']" data-testid="nav-sidebar-settlements-link">
                        <img src="assets/icons/nav-icons-black/settlements.svg" alt="settlements icon" />
                        <span>{{ "navbar.settings_settlements" | translate }}</span>
                    </a>
                }
                @if (authService.allowAccess("members", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-members" (click)="sidebarService.disableSidebar()" [routerLink]="['/members']" data-testid="nav-sidebar-members-link">
                        <img src="assets/icons/nav-icons-black/members.svg" alt="members icon" />
                        <span>{{ "members.members" | translate }}</span>
                    </a>
                }
                @if (authService.isDeveloper() && authService.allowAccess("developer", authService.getRole())) {
                    <a role="button" class="nav-link" id="nav-developer" (click)="sidebarService.disableSidebar()" [routerLink]="['/developer']" data-testid="nav-sidebar-developer-link">
                        <img src="assets/icons/nav-icons-black/developer.svg" alt="developer icon" />
                        <span>Developer</span>
                    </a>
                }
                <div class="log-out">
                    <a role="button" class="nav-link" (click)="signOut()" data-testid="nav-sidebar-log-out-link">
                        <img src="assets/icons/nav-icons-black/log-out.svg" alt="log-out icon" />
                        <span>{{ "navbar.settings_log_out" | translate }}</span>
                    </a>
                </div>
            </nav>
        </div>
    </section>
</aside>
